<template>
  <div class="footer-cookie-notice-wrapper footer-cookie-settings-wrapper" id="CookieSettingsModal">
    <button type="button" class="cookie-consent-overlay"></button>
    <div class="cookie-modal-dialog" id="CookieSettings" tabindex="-1" role="dialog" aria-labelledby="CookieSettings" aria-hidden="true">
      <div class="cookie-modal-main" role="document">
        <div class="cookie-modal-main-content" role="document">
          <div class="cookie-modal-container">
            <div class="col-12 cookie-modal-header">
              <h4>{{ t('cookies.settings') }}</h4>
              <p>{{ t('cookies.settings.main', {params: [{shopname: eshopName}]}) }}</p>
            </div>
            <div class="col-12 cookie-check-row">
              <div class="checkbox">
                <input type="checkbox" class="checkbox_input" id="CookiesRequiredCheckbox" value="1" checked disabled>
                <label class="checkbox_label" for="CookiesRequiredCheckbox">{{ t('cookies.settings.cookies_required') }}</label>
                <p>{{ t('cookies.settings.part1') }}</p>
              </div>
              <div class="checkbox">
                <input type="checkbox" class="checkbox_input" id="CookiesAdvertisingCheckbox" value="1" checked>
                <label class="checkbox_label" for="CookiesAdvertisingCheckbox">{{ t('cookies.settings.cookies_advertising') }}</label>
                <p>{{ t('cookies.settings.part2', {params: [{shopname: eshopName}]}) }}</p>
              </div>
            </div>
            <div class="col-12 cookie-modal-header">
              <p v-html="t('cookies.settings.part3', {params: [{shopname: eshopName, policyurl: policyUrl}]})"></p>
            </div>
            <div class="col-12 cookie-modal-actions-row">
              <div class="row row-mlr-0">
                <div class="col-12 cookie-modal-action-col">
                  <button class="cookie-modal-btn" data-action="consentToCookies" @click="postCookieSettings">
                    {{ t('cookies.settings.consent') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieSettings',
  methods: {
    postCookieSettings () {
      this.$store.commit('updateCookieSettings')
      this.$store.commit('postCookieSettings')
      this.hideModal()
    },
    hideModal () {
      this.$store.commit('hideModal')
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    }
  }
}
</script>
